import request from 'src/request/request';
import { toast } from 'src/utils/notification';


export class TabService {
  private getCurrentGroup(): any {
    return JSON.parse(localStorage.getItem('activeWorkspace') || '{}');
  }

  async setTabsSequence(uuids: string[]) {
    try {
      const response = await request<any, any>( true, 'POST', 'services/workspaces/set-pinned-sequence', { uuids, workspace: this.getCurrentGroup() });
      // console.log('📑 [Tab] sequences:', { uuids, response, workspace: this.getCurrentGroup() });
      return response;
    } catch (error: any) {
      toast.error('setTabsSequence:', error.message);
    }
  }

  async setTab(workspace: any, currentGroup) {
    try {
      const tab = {
        ...workspace,
        data: workspace?.breadcrumb?.currentPage ?? workspace?.data,
        isActive: false,
        widgets: {},
        modals: {},
      };

      const response = await request<any, any>( true,'POST', 'services/workspaces/set-tab', { tab, currentGroup: currentGroup ?? this.getCurrentGroup() });
      // console.log('[Tab] set:', { tab, currentGroup: currentGroup ?? this.getCurrentGroup(), response});
      return response;
    } catch (error: any) {
      toast.error('services/workspaces/set-tab:', error.message);
    }
  }

  async deleteTab(uuid: string) {
    try {
      const response = await request<any, any>( true, 'POST', 'services/workspaces/delete-tab', { uuid, currentGroup: this.getCurrentGroup() });
      // console.log('[Tab] delete:', { uuid, currentGroup: this.getCurrentGroup(), response});
      return response;
    } catch (error: any) {
      toast.error('deleteTab:', error.message);
    }
  }
}
